export default __webpack_public_path__ + "static/media/noimage.d53bf441.png";